import { Signal, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';

export interface SelectOption {
    label: string;
    value: string;
}

/** Turns options whose labels are translation keys into a signal that re-emits once translations load or the language changes. Must run in an injection context. */
export function translatedOptions(options: SelectOption[]): Signal<SelectOption[]> {
    const translate = inject(TranslateService);
    return toSignal(
        translate.stream(options.map((o) => o.label)).pipe(map((texts: Record<string, string>) => options.map((o) => ({ ...o, label: texts[o.label] })))),
        { initialValue: options }
    );
}
